// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPlanAmountPropertyDto } from './IPlanAmountPropertyDto';
import {
    IPlanAmountPropertyDtoFromJSON,
    IPlanAmountPropertyDtoFromJSONTyped,
    IPlanAmountPropertyDtoToJSON,
    IPlanAmountPropertyDtoToJSONTyped,
} from './IPlanAmountPropertyDto';
import type { IAutoEnrollAccountFundingConfigDto } from './IAutoEnrollAccountFundingConfigDto';
import {
    IAutoEnrollAccountFundingConfigDtoFromJSON,
    IAutoEnrollAccountFundingConfigDtoFromJSONTyped,
    IAutoEnrollAccountFundingConfigDtoToJSON,
    IAutoEnrollAccountFundingConfigDtoToJSONTyped,
} from './IAutoEnrollAccountFundingConfigDto';
import type { IHealthPlanDeductibleTriggerConfigDto } from './IHealthPlanDeductibleTriggerConfigDto';
import {
    IHealthPlanDeductibleTriggerConfigDtoFromJSON,
    IHealthPlanDeductibleTriggerConfigDtoFromJSONTyped,
    IHealthPlanDeductibleTriggerConfigDtoToJSON,
    IHealthPlanDeductibleTriggerConfigDtoToJSONTyped,
} from './IHealthPlanDeductibleTriggerConfigDto';
import type { IHealthPlanDeductibleCoverageDto } from './IHealthPlanDeductibleCoverageDto';
import {
    IHealthPlanDeductibleCoverageDtoFromJSON,
    IHealthPlanDeductibleCoverageDtoFromJSONTyped,
    IHealthPlanDeductibleCoverageDtoToJSON,
    IHealthPlanDeductibleCoverageDtoToJSONTyped,
} from './IHealthPlanDeductibleCoverageDto';
import type { ICodePropertyDto } from './ICodePropertyDto';
import {
    ICodePropertyDtoFromJSON,
    ICodePropertyDtoFromJSONTyped,
    ICodePropertyDtoToJSON,
    ICodePropertyDtoToJSONTyped,
} from './ICodePropertyDto';
import type { IEmbeddedAmountPropertyDto } from './IEmbeddedAmountPropertyDto';
import {
    IEmbeddedAmountPropertyDtoFromJSON,
    IEmbeddedAmountPropertyDtoFromJSONTyped,
    IEmbeddedAmountPropertyDtoToJSON,
    IEmbeddedAmountPropertyDtoToJSONTyped,
} from './IEmbeddedAmountPropertyDto';
import type { IMemberAmountPropertyDto } from './IMemberAmountPropertyDto';
import {
    IMemberAmountPropertyDtoFromJSON,
    IMemberAmountPropertyDtoFromJSONTyped,
    IMemberAmountPropertyDtoToJSON,
    IMemberAmountPropertyDtoToJSONTyped,
} from './IMemberAmountPropertyDto';

/**
 * 
 * @export
 * @interface IHealthPlanDeductibleConfigDto
 */
export interface IHealthPlanDeductibleConfigDto {
    /**
     * 
     * @type {number}
     * @memberof IHealthPlanDeductibleConfigDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IHealthPlanDeductibleConfigDto
     */
    parent_id?: number;
    /**
     * 
     * @type {IHealthPlanDeductibleCoverageDto}
     * @memberof IHealthPlanDeductibleConfigDto
     */
    coverage?: IHealthPlanDeductibleCoverageDto;
    /**
     * 
     * @type {ICodePropertyDto}
     * @memberof IHealthPlanDeductibleConfigDto
     */
    code?: ICodePropertyDto;
    /**
     * 
     * @type {IPlanAmountPropertyDto}
     * @memberof IHealthPlanDeductibleConfigDto
     */
    plan_amount?: IPlanAmountPropertyDto;
    /**
     * 
     * @type {IMemberAmountPropertyDto}
     * @memberof IHealthPlanDeductibleConfigDto
     */
    member_amount?: IMemberAmountPropertyDto;
    /**
     * 
     * @type {IEmbeddedAmountPropertyDto}
     * @memberof IHealthPlanDeductibleConfigDto
     */
    embedded_amount?: IEmbeddedAmountPropertyDto;
    /**
     * 
     * @type {Array<IAutoEnrollAccountFundingConfigDto>}
     * @memberof IHealthPlanDeductibleConfigDto
     */
    auto_enroll_account_funding_configs?: Array<IAutoEnrollAccountFundingConfigDto>;
    /**
     * 
     * @type {Array<IHealthPlanDeductibleTriggerConfigDto>}
     * @memberof IHealthPlanDeductibleConfigDto
     */
    trigger_configs?: Array<IHealthPlanDeductibleTriggerConfigDto>;
    /**
     * 
     * @type {Date}
     * @memberof IHealthPlanDeductibleConfigDto
     */
    created_at?: Date;
}

/**
 * Check if a given object implements the IHealthPlanDeductibleConfigDto interface.
 */
export function instanceOfIHealthPlanDeductibleConfigDto(value: object): value is IHealthPlanDeductibleConfigDto {
    return true;
}

export function IHealthPlanDeductibleConfigDtoFromJSON(json: any): IHealthPlanDeductibleConfigDto {
    return IHealthPlanDeductibleConfigDtoFromJSONTyped(json, false);
}

export function IHealthPlanDeductibleConfigDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IHealthPlanDeductibleConfigDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'parent_id': json['parent_id'] == null ? undefined : json['parent_id'],
        'coverage': json['coverage'] == null ? undefined : IHealthPlanDeductibleCoverageDtoFromJSON(json['coverage']),
        'code': json['code'] == null ? undefined : ICodePropertyDtoFromJSON(json['code']),
        'plan_amount': json['plan_amount'] == null ? undefined : IPlanAmountPropertyDtoFromJSON(json['plan_amount']),
        'member_amount': json['member_amount'] == null ? undefined : IMemberAmountPropertyDtoFromJSON(json['member_amount']),
        'embedded_amount': json['embedded_amount'] == null ? undefined : IEmbeddedAmountPropertyDtoFromJSON(json['embedded_amount']),
        'auto_enroll_account_funding_configs': json['auto_enroll_account_funding_configs'] == null ? undefined : ((json['auto_enroll_account_funding_configs'] as Array<any>).map(IAutoEnrollAccountFundingConfigDtoFromJSON)),
        'trigger_configs': json['trigger_configs'] == null ? undefined : ((json['trigger_configs'] as Array<any>).map(IHealthPlanDeductibleTriggerConfigDtoFromJSON)),
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
    };
}

export function IHealthPlanDeductibleConfigDtoToJSON(json: any): IHealthPlanDeductibleConfigDto {
    return IHealthPlanDeductibleConfigDtoToJSONTyped(json, false);
}

export function IHealthPlanDeductibleConfigDtoToJSONTyped(value?: IHealthPlanDeductibleConfigDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'parent_id': value['parent_id'],
        'coverage': IHealthPlanDeductibleCoverageDtoToJSON(value['coverage']),
        'code': ICodePropertyDtoToJSON(value['code']),
        'plan_amount': IPlanAmountPropertyDtoToJSON(value['plan_amount']),
        'member_amount': IMemberAmountPropertyDtoToJSON(value['member_amount']),
        'embedded_amount': IEmbeddedAmountPropertyDtoToJSON(value['embedded_amount']),
        'auto_enroll_account_funding_configs': value['auto_enroll_account_funding_configs'] == null ? undefined : ((value['auto_enroll_account_funding_configs'] as Array<any>).map(IAutoEnrollAccountFundingConfigDtoToJSON)),
        'trigger_configs': value['trigger_configs'] == null ? undefined : ((value['trigger_configs'] as Array<any>).map(IHealthPlanDeductibleTriggerConfigDtoToJSON)),
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
    };
}

